// Minimal tenant predicates — only the flexi rule lives here for now (PB-1837);
// not a refactor of the app's other tenant checks.
export const getTenantId = () => localStorage.getItem('tenantId');

// Penguin Secure / SecureLend are PST-only products; PSPL (111) and PSS (112)
// don't offer them, so Auto Flexi must not exist for those tenants.
export const isFlexiTenant = () => getTenantId() === '110';
